import axios from "axios";

const GETADMIN_API_BASE_URL = "https://doclicapp.herokuapp.com/api/admin/all";
const DELETE_API_BASE_URL = "https://doclicapp.herokuapp.com/api/admin/delete";
const GETSPECIALITY_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/speciality";
const UPDATEADMIN_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/update";
const CHANGESTATUS_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/status";

class ServiceAdmin {
  getAllAdmin() {
    return axios.get(GETADMIN_API_BASE_URL);
  }
  deleteAmdin(adminId) {
    return axios.delete(DELETE_API_BASE_URL + "/" + adminId);
  }

  getSpeciality() {
    return axios.get(GETSPECIALITY_API_BASE_URL);
  }

  changeStatus(adminId) {
    return axios.put(CHANGESTATUS_API_BASE_URL + "/" + adminId);
  }

  updateAdminInfos(id, firstName, lastName, cin, adresse, tel, email, role) {
    return axios.put(UPDATEADMIN_API_BASE_URL, {
      id,
      firstName,
      lastName,
      cin,
      adresse,
      tel,
      email,
      role,
    });
  }
}

export default new ServiceAdmin();
